import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import AdminGateway from '~apis/admin';

import combinedActions from '~redux/combinedActions';
import { GatewayResponseStatus } from '~types/gateway';

import { SagaWatcherReturnType } from '~types/saga';
import { ErrorMessages } from '~utils/constants';
import { ModuleEnum, PermissionsEnum } from '~utils/enums';

import UtilFunctions from '~utils/functions';
import navActions from '~utils/navActions';

export default function* watchStartup(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('auth/authStartupAttempt', handleStartup, api);
}

function* handleStartup(api: AdminGateway) {
    const {
        Auth: {
            getAuthToken,
        },
        SessionStorage: {
            getItem,
        },
    } = UtilFunctions;

    const authToken = getAuthToken();
    const authTokenExp = getItem<number>('authTokenExp');

    if (authToken && authTokenExp && authTokenExp > dayjs().unix()) {
        yield put(combinedActions.authStartupSuccess({ authToken }));
        yield put(combinedActions.authSetAuthToken(authToken));

        const response = yield* call([api, api.getUserDetails], { authToken });

        if (response.status === GatewayResponseStatus.Error) {
            const { message, code } = response;

            if (code === 'TIMEOUT_ERROR') {
                toast.error(ErrorMessages.GenericTimeoutError);
                yield put(combinedActions.authGetUserDetailsFailure(message || ErrorMessages.GenericError));
                yield call(navActions.navResetToLogin);
                return;
            }
        }

        if (response.status === GatewayResponseStatus.Success) {
            const { data: { access } } = response;

            const viewAccessModules = access.find(item => item.permission === PermissionsEnum.View)?.modules || [];

            yield put(combinedActions.authGetUserDetailsSuccess({
                authToken,
                ...response.data,
            }));

            yield put(combinedActions.goldGetGoldPricesAttempt());
            yield put(combinedActions.silverGetSilverPricesAttempt());

            yield put(combinedActions.branchGetAllBranchesAttempt()); // get all branches
            yield put(combinedActions.branchGetAllRegionsAttempt()); // get all regions

            yield put(combinedActions.goldGetAllProductsAttempt()); // get all products

            if (viewAccessModules.includes(ModuleEnum.Inventory)) {
                yield put(combinedActions.goldGetAllInventoriesAttempt()); // get all inventories
            }
        }

        yield call(navActions.navResetToHome);
        return;
    }

    yield call(() => UtilFunctions.Auth.clearAuthToken());
    yield call(() => UtilFunctions.SessionStorage.removeItem('authTokenExp'));

    yield put(combinedActions.authStartupFailure());
}
